import React from 'react';

// `error` (feedback.md 4B): a SHORT message under the control ("Required",
// "Pick a time"). The control itself carries the red ring (errCls).
//
// `layout="row"` (Jaylen 2026-09-17, condensed Contact block): label sits
// LEFT of the control in a fixed 96px column on ≥640px, stacks above it on
// a phone. Tighter vertical rhythm (mb-3) so a short group of fields reads
// as one block — "Full name ___ / Phone # ___ / Email ___".
export default function FormField({ label, children, required, error, className = '', layout = 'stack' }) {
  const lbl = (
    <label className={`block text-xs font-semibold text-slate-600 uppercase tracking-wide ${layout === 'row' ? 'sm:pt-2.5 sm:leading-tight mb-1.5 sm:mb-0' : 'mb-1.5'}`}>
      {label}{required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
  );
  if (layout === 'row') {
    return (
      <div className={`mb-3 sm:grid sm:grid-cols-[96px_1fr] sm:gap-x-3 ${className}`}>
        {lbl}
        <div className="min-w-0">
          {children}
          {error && <p className="text-xs font-semibold text-red-600 mt-1">{error}</p>}
        </div>
      </div>
    );
  }
  return (
    <div className={`mb-5 ${className}`}>
      {lbl}
      {children}
      {error && <p className="text-xs font-semibold text-red-600 mt-1">{error}</p>}
    </div>
  );
}
